var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle 1",
    clipPath: "url(#clip0_339_26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M109.247 53.8456C120.864 76.0163 112.312 103.4 90.145 115.016C67.9785 126.631 40.5946 118.079 28.9769 95.9082C17.3593 73.738 25.9127 46.3553 48.0816 34.7385C70.2509 23.1214 97.6311 31.6791 109.247 53.8456Z",
    fill: "url(#paint0_linear_339_26)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M112.368 88.3906C104.904 112.278 79.4932 125.594 55.6069 118.134C31.7209 110.676 64.4064 105.014 80.585 85.9205C117.709 42.0989 58.7306 24.1625 82.6213 31.6233C106.512 39.0849 119.829 64.4992 112.368 88.3906Z",
    fill: "#F5BC25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_26",
    x1: 48.0793,
    y1: 34.7397,
    x2: 90.145,
    y2: 115.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176055,
    stopColor: "#F5BC25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59159,
    stopColor: "#F5BC25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white",
    transform: "translate(0 50.1284) rotate(-27.6552)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.fe6a42cf53cd506eef396db1bb37c1f7.svg";
export { ForwardRef as ReactComponent };